import {Component, EventEmitter, HostListener, Input, Output} from '@angular/core';
import {Router} from '@angular/router';
import {TimecardStatus} from '../../../model';
import {AnalyticsService} from '../../shared/analytics.service';
import {AuthService} from '../../shared/auth.service';

@Component({
  selector: 'timecard-summary',
  templateUrl: './timecard-summary.component.html',
  styleUrls: ['./timecard-summary.component.scss']
})
export class TimecardSummaryComponent {

  @Input() timecard: Timecard;
  @Input() view: string;
  @Input() selected: boolean;

  @Output() select = new EventEmitter<boolean>();

  masquerading$ = this.Auth.masquerading$;

  Status = TimecardStatus;

  constructor(private Router: Router,
              private Auth: AuthService,
              private Analytics: AnalyticsService) {
  }

  getSignedDate(): Date {
    return this.timecard.statusId === TimecardStatus.Signed ? this.timecard.signed : this.timecard.approved;
  }

  @HostListener('click')
  goToTimecard(): void {
    this.Analytics.trackEvent(`Timecards: View timecard details ${this.timecard.rateTypeId === 2 ? '(Daily Rate)' : '(Standard/DTR)'}`);
    this.Router.navigate(['/timecards', this.timecard.timecardId, 'details'], {
      queryParams: {
        returnTo: 'timecards',
        view: this.view
      }
    });
  }
}
